import { render, staticRenderFns } from "./ServicesView.vue?vue&type=template&id=efa7ef14&scoped=true&"
import script from "./ServicesView.ts?vue&type=script&lang=ts&"
export * from "./ServicesView.ts?vue&type=script&lang=ts&"
import style0 from "./ServicesView.scss?vue&type=style&index=0&id=efa7ef14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa7ef14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VProgressCircular,VRow})
